import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router } from "@angular/router";
import { catchError, Observable, of, tap } from "rxjs";
import { ApplicationResponse } from "../../../shared/models/application.model";
import { ApplicationService } from "../../../shared/services/application.service";

@Injectable({
    providedIn: 'root',
})
export class GetApplicationResolverService implements Resolve<ApplicationResponse> {

    constructor(
        private router: Router,
        private applicationService: ApplicationService,
    ) { }

    resolve(route: ActivatedRouteSnapshot): Observable<ApplicationResponse> {
        const applicationId = Number(route.params['applicationId'] ?? route.parent?.params['applicationId']);

        if (this.applicationService.selectedApplication()?.id !== applicationId) {
            this.applicationService.selectedApplication.set(null);
        }

        return this.applicationService.getById(applicationId)
            .pipe(tap((response: ApplicationResponse) => {
                this.applicationService.selectedApplication.set(response)
            }), 
            catchError((error) => {             
                this.router.navigate(['/error']);   
                return of(null); 
            }));
    }
}
